import { render, staticRenderFns } from "./view_bottom.vue?vue&type=template&id=3e4b8cb2&scoped=true&"
import script from "./view_bottom.vue?vue&type=script&lang=js&"
export * from "./view_bottom.vue?vue&type=script&lang=js&"
import style0 from "./view_bottom.vue?vue&type=style&index=0&id=3e4b8cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b8cb2",
  null
  
)

export default component.exports